/**
 * TenantSwitcher — superadmini kliendivalija. Lubab Vimplal vaadata ühe kliendi
 * andmeid eraldi ("Kõik kliendid" = filtrita). Valik lisab ?tenant=<id> API-kutsetele
 * (vt AuthContext fetch-wrapper) ja laeb lehe uuesti.
 *
 * Kuvatakse AINULT superadminile.
 *
 * Copyright (c) 2025 Vimpla OÜ
 */
import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export function TenantSwitcher() {
  const { isSuperadmin, viewTenant, setViewTenant } = useAuth();
  const [tenants, setTenants] = useState([]);

  useEffect(() => {
    if (!isSuperadmin) return;
    let cancelled = false;
    fetch('/api/auth/tenants', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : { tenants: [] }))
      .then((j) => { if (!cancelled) setTenants(j.tenants || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [isSuperadmin]);

  if (!isSuperadmin) return null;

  return (
    <div className="px-2 py-2 border-b border-[var(--border)]">
      <label className="px-2 text-[10px] uppercase tracking-wider text-zinc-400">Klient</label>
      <select
        value={viewTenant || ''}
        onChange={(e) => {
          const id = e.target.value || null;
          setViewTenant(id, tenants.find((t) => t.id === id)?.name);
        }}
        className="mt-1 w-full px-2 py-1.5 rounded text-[13px] font-medium text-zinc-700 bg-white border border-[var(--border)] focus:outline-none focus:ring-1 focus:ring-zinc-400"
        title="Superadmin: vaata ühe kliendi andmeid"
      >
        <option value="">Kõik kliendid</option>
        {tenants.map((t) => (
          <option key={t.id} value={t.id}>{t.name || t.id}</option>
        ))}
      </select>
    </div>
  );
}
